export default function redirectWithFlashMessage(redirectTo, { type, key }) {
  window.location = `/redirect_with_flash?redirect_to=${encodeURIComponent(
    redirectTo
  )}&flash_type=${encodeURIComponent(type)}&flash_key=${encodeURIComponent(
    key
  )}`
}
